import {
  PRODUCTINVENTORY_LOADING,
  GET_PRODUCTINVENTORY,
  GET_PRODUCTINVENTORY_SUCCESS,
  GET_PRODUCTINVENTORY_FAIL,
  ADD_PRODUCTINVENTORY_SUCCESS,
  ADD_PRODUCTINVENTORY_FAIL,
  DELETE_PRODUCTINVENTORY_SUCCESS,
  DELETE_PRODUCTINVENTORY_FAIL,
  UPDATE_PRODUCTINVENTORY_SUCCESS,
  UPDATE_PRODUCTINVENTORY_FAIL,
  PRODUCTINVENTORY_RESET
} from "./actionType";

const INIT_STATE = {
  productInventories: [],
  error: {},
};

const ProductInventory = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCTINVENTORY_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PRODUCTINVENTORY:
          return {
            ...state,
            productInventories: action.payload.data,
            isProductInventoryCreated: false,
            isProductInventorySuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PRODUCTINVENTORY_FAIL:
      switch (action.payload.actionType) {
        case GET_PRODUCTINVENTORY_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isProductInventoryCreated: false,
            isProductInventorySuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PRODUCTINVENTORY: {
      return {
        ...state,
        isProductInventoryCreated: false,
        loading: true,
      };
    }

    case PRODUCTINVENTORY_LOADING: {
      return {
        ...state,
        isProductInventoryCreated: false,
        loading: true,
      };
    }

    case ADD_PRODUCTINVENTORY_SUCCESS:
      return {
        ...state,
        isProductInventoryCreated: true,
        loading: false,
        productInventories: [action.payload.data, ...state.productInventories],
      };

    case ADD_PRODUCTINVENTORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PRODUCTINVENTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        isProductInventoryCreated: true,
        productInventories: state.productInventories.filter(
          productInventory => productInventory.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PRODUCTINVENTORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PRODUCTINVENTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        isProductInventoryCreated: true,
        productInventories: state.productInventories.map(productInventory =>
          productInventory.id.toString() === action.payload.data.id.toString() ? { ...productInventory, ...action.payload.data } : productInventory
        ),
      };

    case UPDATE_PRODUCTINVENTORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PRODUCTINVENTORY_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default ProductInventory;